import { useState, useEffect } from 'react';

/**
 * Hook to handle localStorage values reactively.
 * @param {string} key - The localStorage key.
 * @param {*} defaultValue - Default value if it doesn't exist in localStorage.
 * @returns {[any, function]} [value, setValue]
 */
function useLocalStorage(key, defaultValue) {
  // Read initial value from localStorage or use defaultValue
  const getInitialValue = () => {
    try {
      const storedValue = localStorage.getItem(key);
      if (storedValue !== null) {
        return JSON.parse(storedValue);
      }
      return defaultValue;
    } catch (err) {
      return defaultValue;
    }
  };

  const [value, setValue] = useState(getInitialValue);

  // Update localStorage when value changes
  useEffect(() => {
    try {
      if (value === undefined) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (err) {
      console.error('Error saving to localStorage', err);
    }
  }, [key, value]);

  return [value, setValue];
}

export default useLocalStorage;
